import { ICanTranslate } from "../../domain/translations/ICanTranslate";
import { restApiHelperWithoutBaseUrl } from "../helpers/RestApiHelper";
import { ILocalRepository } from "../../domain/app/ILocalRepository";
import { appDependencies } from "../../domain/AppDependencies";
import { LocalStorageKeys } from "../../domain/app/LocalStorageKeys";
import { EnumMessageToDisplayType } from "../../domain/notifications/EnumMessageToDisplayType";
import { appEmit } from "../../domain/AppDomain";
import { EventNames } from "../../domain/events/Events";
import { ICanNotify } from "../../domain/notifications/ICanNotify";

export class TranslationPlug implements ICanTranslate {
    private _currentTranslations: Culture | null = null;
    private _notifier: ICanNotify;
    private _localStorageHelper: ILocalRepository;

    constructor() {
        this._notifier = appDependencies.ICanNotify;
        this._localStorageHelper = appDependencies.ILocalRepository;
    }

    async loadCulture(cultureCode: string): Promise<any> {
        this._currentTranslations = new Culture();
        try {
            const translationSource = await Promise.all([restApiHelperWithoutBaseUrl.getData(`/assets/cultures/${cultureCode}.json`)]);
            translationSource.forEach(t => Object.assign(this._currentTranslations || {}, t));
            this._setCultureCodeAndWriteToStorage(cultureCode);
            appEmit(EventNames.languageChanged)
        } catch (error) {
            return this._notifier.notify({
                title: "Could not load language",
                body: error,
                type: EnumMessageToDisplayType.error
            });
        }
    }

    private _setCultureCodeAndWriteToStorage = (currentCultureCode: string) => this._localStorageHelper.store(LocalStorageKeys.currentLanguage, currentCultureCode);

    translate(translationKey: string, obj = {}): string {
        const objIsEmpty = (Object.keys(obj).length === 0 && obj.constructor === Object);

        if (this._currentTranslations) {
            let matchingTranslation = (this._currentTranslations as any)[translationKey];

            if (!objIsEmpty) {
                for (const p in obj) {
                    if (obj.hasOwnProperty(p)) {
                        matchingTranslation = matchingTranslation.replace(`{{${p}}}`, (obj as any)[p]);
                    }
                }
            }
            if (!matchingTranslation) {
                const w = (window as any);
                w.missingTranslations = w.missingTranslations || {};
                w.missingTranslations[translationKey] = "";
                if (!("translations" in window)) {
                    Object.defineProperty(w, "translations", {
                        get: () => console.log(Object.keys(w.missingTranslations).map(x => `"${x}": "",`).join("\r\n"))
                    });
                }
            }
            return matchingTranslation || translationKey;
        }
        return translationKey;
    }
}

export class Culture {
    public translations: Translation[] = [];
}

export class Translation {
    public key: string = "";
    public text: string = "";
}
